import { MoreHorizontal } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'

/** The "⋯" of the views (spec-63 E5): extra actions on the list as it is on screen, e.g. "Opslaan als lijst…". */
export function ViewMenu({ onSaveAsList, className }: { onSaveAsList: () => void; className?: string }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="ghost" size="sm" className={className} aria-label="Meer acties voor deze weergave">
          <MoreHorizontal aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={onSaveAsList}>Opslaan als lijst…</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
